import { render } from "./approval_step.vue?vue&type=template&id=7ffb3706"
import script from "./approval_step.vue?vue&type=script&lang=js"
export * from "./approval_step.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__